<template src="./template.html"></template>

<script>
  import { mapActions, mapState, mapGetters } from 'vuex'

  import PaymentAmazonPay from '../paymentTypes/PaymentAmazonPay'
  import PaymentElectronicCash from '../paymentTypes/PaymentElectronicCash'
  import PaymentKlarna from '../paymentTypes/PaymentKlarna'

  export default {
    name: 'CartPayment',
    components: {
      PaymentAmazonPay,
      PaymentElectronicCash,
      PaymentKlarna,
    },
    props: {
      index: Number,
      isTabActive: Boolean,
      showPayment: Boolean,
      invalid: Boolean,
      validated: Boolean,
    },
    data() {
      return {
        timer: null,
      }
    },
    computed: {
      ...mapState('payment', [
        'paymentServices',
        'activePaymentService',
      ]),
      ...mapState('cart', ['comment']),
      ...mapState('settings', ['settings']),
      activePayment: {
        get() {
          return this.activePaymentService
        },
        set(value) {
          this.updatePaymentServiceAndSetSelectedPayment(value)
        },
      },
      cartComment: {
        get() {
          return this.comment
        },
        set(value) {
          this.performUpdateComment(value)
        },
      },
      ...mapGetters('payment', ['isPending']),
      customer() {
        return process.env.customer
      },
      isCheckoutComment() {
        return this.settings?.active_features?.checkout_comment_section
      },
    },
    watch: {
      activePaymentService: {
        handler(newVal, oldVal) {
          if (newVal !== oldVal && newVal !== null) {
            this.updatePaymentServiceAndSetSelectedPayment(newVal)
          }
        },
        immediate: true,
      },
    },
    async created() {
      this.getPaymentServices()
      this.$store.subscribe(mutation => {
        switch (mutation.type) {
          case 'deliveryAddress/UPDATE_DELIVERY_ADDRESS_ACTIVE':
          case 'deliveryAddress/LAST_UPDATE_ADDRESS':
          case 'invoiceAddress/LAST_UPDATE_ADDRESS':
          case 'vouchers/ADD_VOUCHER':
          case 'vouchers/REMOVE_VOUCHER':
            this.getPaymentServices()
            break
          default:
            return false
        }
      })
      await this.getSettings()
    },
    methods: {
      ...mapActions('payment', [
        'getPaymentServices',
        'updatePaymentService',
      ]),
      ...mapActions('cart', ['updateComment']),
      ...mapActions('settings', ['getSettings']),
      performUpdateComment(comment) {
        clearTimeout(this.timer)
        this.timer = setTimeout(_ => {
          this.updateComment(comment)
        }, 750)
      },
      async updatePaymentServiceAndSetSelectedPayment(value) {
        await this.updatePaymentService(value)
        if (window.paymentSelected && typeof (
              window.paymentSelected === 'function'
          )) {
          window.paymentSelected(value)
        }
      },
    },
  }
</script>
